import React from 'react'
import { connect } from 'react-redux'
// import moment from 'moment'
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';

import DRP from './inputs/DashboardRangePicker'
import FormSelect from './inputs/FormSelect'

import ResponsiveLine from './graphs/ResponsiveLine'
import ResponsiveBar from './graphs/ResponsiveBar'
import ResponsivePie from './graphs/ResponsivePie'

import Loader from './Loader'

import {
  format_number
} from '../helpers'

import {
  get_graphs,
  reset_graphs,
  clear_graph_dates,
  skills_index
} from '../actions'

const mapStateToProps = state => {
  const { data, from, to, time_start, total_users, total_tests, total_paid, fetching, fetched, timestamp, errors } = state.graph
  return {
    graphs: data,
    from, to, time_start,
    total_users, total_tests, total_paid,
    fetching, fetched,
    timestamp, errors,
    current_user: state.auth.current_user.data,
    skills: state.skill.items
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getGraphs: (graph_types=[], from=null, to=null, skill=null) => dispatch( get_graphs(graph_types, from, to, skill) ),
    resetGraphs: () => dispatch( reset_graphs() ),
    getSkills: () => dispatch( skills_index() ),
    clearDates: () => dispatch( clear_graph_dates() ),
  }
}

class ConnectedDashboard extends React.PureComponent {
  state = {
    from: null,
    to: null,
    timestamp: null,
    graph_types: [],
    graph_config: [],
    mounted: false,
    variant: 'admin'
  }

  graph_types = {
    admin: ['tests_served','tests_per_skill','payment_types','income_per_skill','income_per_payment_type'],
    expert: ["creators_performance","questions_status","template_usage","question_levels","test_levels","own_question_levels"],
    creator: ["own_question_levels"]
  }

  graph_config = {
    admin: [
      {
        id: 'tests_served', type: 'line', md: 12, xs: 12, yaxis: 'Tests Taken', xaxis: "",
        title: 'INSTANCES SERVED', subtitle: "Number of instances served (coupon vs full paid tests)",
        rotateOnSmall: true, headers: { paid: {text: "Fully Paid" }, coupons: {text: "Coupon" }, count: {text: "All"} }
      },
      {
        id: 'tests_per_skill', type: 'bar', md: 8, xs: 12, yaxis: "Tests Taken", xaxis: "Skill",
        title: 'CREDIT USAGE', subtitle: "Breakdown of fully paid vs coupon usage per skill",
        rotateOnSmall: true, headers: ["label", "paid", "coupons"], match: {paid: "Fully Paid", coupons: "Coupon"}, color: 'bright'
      },
      {
        id: 'tests_per_skill', type: 'pie', md: 4, xs: 12, variant: "percent",
        title: 'SKILL USAGE', subtitle: "% instances served per skill",
      },
      {
        id: 'payment_types', type: 'pie', md: 4, xs: 12, variant: "percent",
        title: 'PAYMENT TYPE', subtitle: "Full payment vs Coupon % share", color: 'bright'
      },
      {
        id: 'income_per_skill', type: 'pie', md: 4, xs: 12, variant: "thousands", valueTag: "€",
        title: 'INCOME PER SKILL', subtitle: "Aggregate Earnings / Skill", decimals: true
      },
      {
        id: 'income_per_payment_type', type: 'pie', md: 4, xs: 12, variant: "thousands", valueTag: "€",
        title: 'EARNINGS PER PAYMENT TYPE', subtitle: "Full payment vs Coupon Earnings", color: 'bright', decimals: true
      },
    ],
    expert: [
      {
        id: 'creators_performance', type: 'bar', md: 8, xs: 12, yaxis: 'Questions', xaxis: "Data content creators",
        title: 'DATA CONTENT CREATOR PERFORMANCE', subtitle: "Number of questions per creator",
        headers: ["label", "trashed", "draft", "published" ], rotateOnSmall: true, match: {trashed: "Trashed", draft: "Draft", published: "Published"}
      },
      {
        id: 'questions_status', type: 'pie', md: 4, xs: 12, variant: "percent",
        title: 'QUESTION STATUS', subtitle: "Status of skill's questions",
      },
      {
        id: 'template_usage', type: 'pie', md: 4, xs: 12, variant: "percent",
        title: 'TEMPLATE USAGE', subtitle: "# instances per template",
      },
      {
        id: 'question_levels', type: 'bar', md: 8, xs: 12, yaxis: '# of questions', xaxis: "Levels",
        title: 'QUESTION STATUS / LEVEL', subtitle: "Overview of skill questions status per level",
        headers: ["label", "trashed", "draft", "published" ], match: {trashed: "Trashed", draft: "Draft", published: "Published"}
      },
      {
        id: 'test_levels', type: 'pie', md: 4, xs: 12, variant: "percent",
        title: 'RESULTS PER LEVEL', subtitle: "% instances per level",
      },
      {
        id: 'own_question_levels', type: 'bar', md: 8, xs: 12, yaxis: '# of questions', xaxis: "Levels",
        title: 'OWN QUESTION STATUS / LEVEL', subtitle: "Overview of own questions status per level",
        headers: ["label", "trashed", "draft", "published" ], match: {trashed: "Trashed", draft: "Draft", published: "Published"}
      },
    ],
    creator: [
      {
        id: 'own_question_levels', type: 'bar', md: 12, xs: 12, yaxis: '# of questions', xaxis: "Levels",
        title: 'OWN QUESTION STATUS / LEVEL', subtitle: "Overview of own questions status per level",
        headers: ["label", "trashed", "draft", "published" ], match: {trashed: "Trashed", draft: "Draft", published: "Published"}
      },
    ]
  }

  componentWillMount() {
    const { timestamp, current_user, getGraphs, resetGraphs, to } = this.props
    const from = null//moment().startOf('year').format()
    resetGraphs()

    if ( this.props.skills.length === 0 ) {
      this.props.getSkills()
    }

    const graph_types = this.graph_types[current_user.role]
    const graph_config = this.graph_config[current_user.role]

    this.setState({from, to, timestamp, graph_types, graph_config})
    getGraphs(graph_types, from, to)

  }

  componentDidUpdate(prevProps, prevState) {
    // if (!this.state.mounted && this.props.timestamp !== prevProps.timestamp ) {
    if (!this.state.mounted && prevProps.timestamp === null && this.props.timestamp !== prevProps.timestamp && this.props.time_start !== null) {
      this.props.getGraphs(this.state.graph_types, this.props.time_start, this.props.to, this.state.variant )
      // return this.setState({mounted: true})
    } else if (!this.state.mounted && this.props.timestamp !== prevProps.timestamp && this.props.time_start !== null) {
      return this.setState({mounted: true})
    }
    if (prevProps.timestamp !== this.props.timestamp) {
      const { from, to, timestamp } = this.props
      this.setState({ from, to, timestamp })
    }
  }

  handleView(e) {
    if (this.props.current_user.role !== 'admin') {
      return
    }
    const { value } = e.target
    const {from, to} = this.props
    if (value !== 'admin') {
      if (this.state.variant === 'admin') {
        this.props.clearDates()
        this.setState({mounted: false})
      }
      this.setState({ graph_types: this.graph_types['expert'], graph_config: this.graph_config['expert']})
      this.props.getGraphs(this.graph_types['expert'], from, to, value)
    } else {
      if (this.state.variant !== 'admin') {
        this.props.clearDates()
        this.setState({mounted: false})
      }
      this.setState({ graph_types: this.graph_types['admin'], graph_config: this.graph_config['admin']})
      this.props.getGraphs(this.graph_types['admin'], from, to, value)
    }
    this.setState({variant: value})
  }

  handleDates = (dates) => {
    // console.log(dates)
    const {from, to} = dates
    if (this.props.current_user.role === 'admin' && this.state.variant !== 'admin') {
      this.props.getGraphs(this.state.graph_types, from, to, this.state.variant)
    } else {
      this.props.getGraphs(this.state.graph_types, from, to, this.state.variant)
    }
  }

  render() {
    const { graphs, total_users, total_tests, total_paid, current_user, time_start } = this.props
    const { mounted, graph_config } = this.state
    const { from, to, } = this.props
    if ( !mounted  ) {
      return <Loader />
    }

    const display_total_paid = input => {
      if (!input) {
        return `€ 0.0 K`
      }
      let thousands = parseInt(input/1000, 10)
      const units     = input % 1000
      let hundreds  = Math.round(units/100)
      if (hundreds === 10) {
        thousands = thousands + 1
        hundreds  = 0
      }
      return `€ ${thousands}.${hundreds} K`
    }

    return(
      <div className="instalevel-dashboard">
        <Grid container spacing={24} justify="space-between">
          <Grid item xs={12} md={12} use="header">
            <Paper className="dashboard-paper" square={true}>
              <Grid container spacing={24} justify="space-between" alignItems="center">
                <Grid item className="dashboard-text dashboard-title" xs={12} md={6}>
                  Dashboard
                </Grid>
                <Grid item className="dashboard-text dashboard-picker" xs={12} md={6} container justify="flex-end">
                  { current_user.role === 'admin' && (
                    <Grid item className="mr-24 dashboard-variant-picker" >
                      <FormSelect
                        value={this.state.variant}
                        onChange={(e) => this.handleView(e)}
                      >
                        <MenuItem className="dashboard-menu-item" value='admin'>Admin</MenuItem>
                        <MenuItem className="dashboard-menu-item dashboard-disabled-item" disabled value='chooser'>Choose Skill:</MenuItem>
                        {
                          this.props.skills.map( skill => {
                            return <MenuItem className="dashboard-menu-item" key={skill.id} value={skill.name}>{skill.name}</MenuItem>
                          })
                        }
                      </FormSelect>
                    </Grid>
                  )}
                  <Grid item>
                    <DRP
                      startDate={from}
                      endDate={to}
                      timeStart={time_start}
                      handleChange={ dates => {
                        this.handleDates(dates)
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          { current_user.role === 'admin' && this.state.variant === 'admin' && (
            <React.Fragment>
              <Grid item xs={4} md={4}>
                <Paper className="dashboard-paper" square={true}>
                  <div className="dashboard-graph-title dashboard-totals-title">NEW USERS</div>
                  <div className="dashboard-graph-data dashboard-totals-data">{format_number(total_users, false)}</div>
                </Paper>
              </Grid>
              <Grid item xs={4} md={4}>
                <Paper className="dashboard-paper" square={true}>
                  <div className="dashboard-graph-title dashboard-totals-title">TESTS TAKEN</div>
                  <div className="dashboard-graph-data dashboard-totals-data">{format_number(total_tests, false)}</div>
                </Paper>
              </Grid>
              <Grid item xs={4} md={4}>
                <Paper className="dashboard-paper" square={true}>
                  <div className="dashboard-graph-title dashboard-totals-title">TOTAL EARNINGS</div>
                  <div className="dashboard-graph-data dashboard-totals-data">{display_total_paid(total_paid)}</div>
                </Paper>
              </Grid>
            </React.Fragment>
          )}

          {
            graph_config.map( (gc, i) => {
              const { id, xs, md, title, subtitle, headers, xaxis, yaxis, type, variant, graph_data, match, color, rotateOnSmall, valueTag, decimals} = gc
              const graphData = graph_data || graphs[id]
              const comp = (type === 'pie') ? (
                <ResponsivePie
                  graphData={graphData}
                  color={color}
                  variant={variant}
                  decimals={decimals}
                  valueTag={valueTag}
                  id={id}
                />
              ) : ( type === 'bar') ? (
                <ResponsiveBar
                  headers={headers}
                  graphData={graphData}
                  xaxis={xaxis}
                  yaxis={yaxis}
                  match={match}
                  color={color}
                  rotateOnSmall={rotateOnSmall}
                />
              ) : (
                <ResponsiveLine
                  headers={headers}
                  graphData={graphData}
                  rotateOnSmall={rotateOnSmall}
                  xaxis={xaxis}
                  yaxis={yaxis}
                />
              )
              return (
                <Grid key={`graph_${i}`} item xs={xs} md={md}>
                  <Paper className="dashboard-paper" square={true} >
                    <div className="dashboard-graph-title">{title}</div>
                    <div className="dashboard-graph-subtitle">{subtitle}</div>
                    <div style={{height: 400}} className={`instalevel-${type}-chart`} id={id}>
                      { comp }
                    </div>
                  </Paper>
                </Grid>
              )
            })
          }

        </Grid>
      </div>
    )
  }
}

const Dashboard = connect(mapStateToProps, mapDispatchToProps)(ConnectedDashboard)
export default Dashboard



// WEBPACK FOOTER //
// ./src/js/components/Dashboard.js